import Cookies from 'js-cookie';

import PoliciesController from './policies';

class GateController {

	gates = {};

	flags = {};

	initialize() {
		this.updateGatesFromCookies();
	}

	updateGatesFromCookies() {
		if (!PoliciesController.isNoCookies) {
			const cookies = Cookies.get();
			for (const i in cookies) {
				if (i.indexOf('gate_') === 0) {
					const gateId = i.split('gate_')[1];
					const cookiObj = JSON.parse(cookies[i]);
					this.gates[gateId] = {
						validated: cookiObj.validated
					};
				}
			}
		}
	}

	getGateStatus(gateId) {
		if (this.gates[gateId]) {
			return this.gates[gateId].validated;
		}
		return null;
	}

	setGateStatus(gateId, isValidated) {
		const gate = this.gates[gateId];

		if (gate) {
			gate.validated = (isValidated === true);
		} else {
			this.gates[gateId] = {
				validated: (isValidated === true)
			};
		}

		if (!PoliciesController.isNoCookies) {
			Cookies.set(`gate_${gateId}`, JSON.stringify({ validated: isValidated }));
		}
	}

	needsGate(modalId) {
		const gate = this.gates[modalId];
		let decision = false;
		if (!gate) {
			decision = true;
		} else if (gate.validated !== true) {
			decision = true;
		}
		return decision;
	}

}

export default new GateController();
